import { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const IMG_TYPES = ["image/png", "image/jpeg", "image/webp", "image/svg+xml", "image/gif"];

export const GangUploader = ({ onAdd }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const list = Array.from(e.target.files || []);
    e.target.value = "";
    setBusy(true);
    for (const f of list) {
      if (!IMG_TYPES.includes(f.type)) { toast.error(`${f.name}: use PNG, JPG, WEBP or SVG`); continue; }
      try {
        const src = URL.createObjectURL(f);
        const img = await new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = src; });
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/uploads/artwork", fd);
        onAdd({ src, path: data.path, filename: data.filename, aspect: img.naturalHeight / img.naturalWidth || 1 });
      } catch (err) { toast.error(`${f.name}: ${errMsg(err)}`); }
    }
    setBusy(false);
  };
  return (
    <>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="btn-red w-full" data-testid="gang-upload-button">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <ImagePlus className="h-5 w-5" />} Upload Pictures
      </button>
      <input ref={ref} type="file" multiple hidden accept="image/png,image/jpeg,image/webp,image/svg+xml,image/gif" onChange={pick} data-testid="gang-upload-input" />
      <p className="text-xs text-slate-500">Transparent PNGs work best. Upload several at once.</p>
    </>
  );
};
